var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRoundedArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61664 3.32325C9.54784 3.22332 9.45577 3.14161 9.34837 3.08517C9.24098 3.02872 9.12147 2.99923 9.00014 2.99923C8.87881 2.99923 8.75931 3.02872 8.65191 3.08517C8.54451 3.14161 8.45245 3.22332 8.38364 3.32325L1.63364 13.0732C1.55551 13.1857 1.5097 13.3174 1.50117 13.4541C1.49264 13.5908 1.52173 13.7272 1.58528 13.8485C1.64883 13.9698 1.7444 14.0713 1.86162 14.1421C1.97883 14.2129 2.11321 14.2502 2.25014 14.25L15.7501 14.25C15.8868 14.2494 16.0206 14.2116 16.1374 14.1407C16.2541 14.0697 16.3493 13.9683 16.4127 13.8473C16.4761 13.7262 16.5053 13.5902 16.4972 13.4539C16.4891 13.3175 16.4439 13.1859 16.3666 13.0732L9.61664 3.32325Z",
    className: "svgFill"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoundedArrow);
export default __webpack_public_path__ + "static/media/rounded_arrow.d3291e44.svg";
export { ForwardRef as ReactComponent };